import type { DrawLevel } from '@ps/web-shared-api-types/v1-preview/SwPkrSpinAndGo';
import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import sharedStyles from '../shared.scss';

import { TXTCLI_Blinds, TXTCLI_Level } from './BlindLevel.messages.json';
import styles from './BlindLevel.scss';

interface BlindLevelProps {
  stakeLevels: DrawLevel['stakeLevels'];
}

const BlindLevel: React.FC<BlindLevelProps> = ({ stakeLevels }) => (
  <div className={classNames(styles.blindLevels, sharedStyles.scrollableTable)}>
    <table>
      <thead>
        <tr>
          <th>
            <Translation {...TXTCLI_Level} />
          </th>
          <th>
            <Translation {...TXTCLI_Blinds} />
          </th>
        </tr>
      </thead>

      <tbody>
        {stakeLevels &&
          stakeLevels.map((stakeLevel, index) => (
            <tr key={`${stakeLevel}-${index}`}>
              <td>{index + 1}</td>
              <td>{stakeLevel}</td>
            </tr>
          ))}
      </tbody>
    </table>
  </div>
);

export default BlindLevel;
